import { createEffect } from '../utils/store';

export const setBannerAPIRequestState = createEffect(
  'SET_BANNER_API_REQUEST_STATE',
);
export const userInviteError = createEffect('USER_INVITE_ERROR');
